import axios from 'axios';

export default {
  namespaced: true,
  state: {
    all: [],
  },
  getters: {
    getAll(state) {
      return state.all;
    },
    byId(state) {
      return state.all.reduce((total, current) => {
        total[current.id] = current;
        return total;
      }, {});
    },
  },
  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'motorconfig_motor_types')
        .then(({ data }) => {
          commit('setTypes', data);
        });
    },
  },
  mutations: {
    setTypes(state, types) {
      state.all = types;
    },
  },
};
